/** Formal appointment only, not a workspace permission/preview role. */
export function ClusterLeaderBadge({active}:{active?:boolean|number}){
  return active?<span className="op-status">Cluster Leader</span>:null;
}
